<template>
  <section class="admin">
    <div class="app">
      <div class="mobile-menu md:hidden">
        <div class="mobile-menu-bar">
          <a href="" class="flex mr-auto">
            <img alt="My Inxait" class="w-6" src="/static/images/logo.svg" />
          </a>
          <a href="javascript:;" @click="menuMobile">
            <app-icon
              name="bars"
              classname="w-8 h-8 text-white transform -rotate-90"
            ></app-icon>
          </a>
        </div>
        <ul class="border-t border-theme-29 py-5 d-block" v-if="!openmenu">
          <app-side-bar classname="menu"></app-side-bar>
        </ul>
      </div>
      <div class="flex">
        <nav class="side-nav">
          <a href="#" class="intro-x flex items-center pl-5 pt-4">
            <img
              alt="Logo"
              class="w-32 xl:block"
              src="/static/images/LOGO-WHITE-2026.png"
            />
          </a>
          <div class="side-nav__devider my-6"></div>
          <app-side-bar classname="side-menu"></app-side-bar>
        </nav>
        <div class="content">
          <app-top></app-top>
          <div class="grid grid-cols-12 gap-6 mt-8">
            <div class="col-span-12">
              <h2 class="intro-y text-lg font-medium mr-auto mt-2">
                Administrativo
              </h2>
              <!-- BEGIN: File Manager Menu -->
              <div class="intro-y box p-5 mt-6">
                <div class="mt-1 grid grid-cols-5 gap-6">
                  <router-link
                    to="/admin/business/budgets"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="
                      subIsActive('/admin/business/budgets')
                        ? 'bg-theme-1 text-white font-medium'
                        : 'bg-theme-2'
                    "
                  >
                    <app-icon name="briefcase" classname="w-4 h-4 mr-2" />
                    Presupuestos
                  </router-link>
                  <router-link
                    to="/admin/business/clients"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="
                      subIsActive('/admin/business/clients')
                        ? 'bg-theme-1 text-white font-medium'
                        : 'bg-theme-2'
                    "
                  >
                    <app-icon name="file" classname="w-4 h-4 mr-2" /> Clientes
                  </router-link>
                  <router-link
                    to="/admin/business/suppliers"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="
                      subIsActive('/admin/business/suppliers')
                        ? 'bg-theme-1 text-white font-medium'
                        : 'bg-theme-2'
                    "
                  >
                    <app-icon name="grid" classname="w-4 h-4 mr-2" />
                    Proveedores
                  </router-link>
                  <router-link
                    to="/admin/business/social-reasons"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="
                      subIsActive('/admin/business/social-reasons')
                        ? 'bg-theme-1 text-white font-medium'
                        : 'bg-theme-2'
                    "
                  >
                    <app-icon name="briefcase" classname="w-4 h-4 mr-2" />
                    Razones Sociales
                  </router-link>
                  <router-link
                    to="/admin/business/campaigns"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="
                      subIsActive('/admin/business/campaigns')
                        ? 'bg-theme-1 text-white font-medium'
                        : 'bg-theme-2'
                    "
                  >
                    <app-icon name="file" classname="w-4 h-4 mr-2" /> Campañas
                  </router-link>
                </div>
              </div>
              <!-- END: File Manager Menu -->
            </div>
            <div class="col-span-12">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Top from '@/components/admin/partials/Top'
import SideBar from '@/components/admin/partials/SideBar'

export default {
  data() {
    return {
      openmenu: true,
    }
  },
  mounted() {
    if (localStorage.token) {
      this.session()
        .then((user) => {
          this.loading = false
        })
        .catch((message) => {
          this.loading = false
          this.$router.replace(this.$route.query.redirect || '/')
        })
    } else {
      this.loading = false
      this.$router.replace('/')
    }
  },
  methods: {
    ...mapActions(['session']),
    menuMobile() {
      var menu = this.openmenu
      console.log('clic')
      this.openmenu = !menu
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0
      })
    },
  },
  components: {
    appTop: Top,
    appSideBar: SideBar,
    appIcon: Icon,
  },
}
</script>



// WEBPACK FOOTER //
// AdminBusiness.vue?3dd4fd6f